/* Silvur Street — story section: play-in-view, pause-out-of-view stage clips.
   Progressive enhancement: content is visible by default (no JS). Only when this
   script runs does it add a .js-silvur class to the section, which lets the CSS
   hide the stage copy until it scrolls into view. A script failure can never
   blank the page again.
   Respects prefers-reduced-motion (no autoplay, first frame only). */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia &&
    window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function init(section) {
    if (!section) return;
    var stages = section.querySelectorAll('.silvur-story__stage');
    if (!stages.length) return;

    // Signal that JS is active so the CSS fade-in may apply. Without this the
    // copy stays fully visible even if the rest of the script fails.
    section.classList.add('js-silvur');

    if (reduceMotion) {
      // Show the first frame, never autoplay; keep copy visible.
      stages.forEach(function (stage) {
        stage.classList.add('is-in-view');
        var video = stage.querySelector('video');
        if (video) {
          video.removeAttribute('autoplay');
          video.pause();
          video.currentTime = 0;
        }
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      // Fallback: play everything on load, keep copy visible.
      stages.forEach(function (stage) {
        stage.classList.add('is-in-view');
        var video = stage.querySelector('video');
        if (video) video.play().catch(function () {});
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var stage = entry.target;
        var video = stage.querySelector('video');

        if (entry.isIntersecting) {
          stage.classList.add('is-in-view');
          if (video) video.play().catch(function () {});
        } else if (video) {
          video.pause();
        }
      });
    }, {
      threshold: 0.35,
      rootMargin: '0px 0px -10% 0px'
    });

    stages.forEach(function (stage) {
      observer.observe(stage);
    });
  }

  function boot() {
    document.querySelectorAll('[data-silvur-story]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
